import { useKeycloak } from '@react-keycloak/web';
import { useEffect, useState } from 'react';
import { useHttpClient } from 'src/security/hooks/axiosProvider';

export const useTpes = () => {
  const [tpes, setTpes] = useState([]);
  const httpClient = useHttpClient();
  const { keycloak } = useKeycloak();

  useEffect(() => {
    const fetchTpes = async () => {
      const isSuperAdmin = keycloak.hasResourceRole('ROLE_AGRISED_ADMIN_SUPER') ?? false;
      const userId = keycloak.tokenParsed?.sub;

      const response = await httpClient.current?.get(`/api/tpe`);
      const data = response?.data || [];

      if (isSuperAdmin) {
        setTpes(data);
      } else {
        const filteredTpes = data.filter(
          (tpe) => tpe.user?.id === userId || tpe.project?.administrator?.id === userId
        );
        setTpes(filteredTpes);
      }
    };

    fetchTpes();
  }, [httpClient, keycloak]);

  return { tpes };
};